// UserPaymentSuccess.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const API_URL = process.env.REACT_APP_API_URL;

function isTokenExpired(token) {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expiry = payload.exp;
    return expiry < Math.floor(Date.now() / 1000);
  } catch {
    return true;
  }
}

const PaymentSuccess = () => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const location = useLocation();
    const navigate = useNavigate();

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const query = new URLSearchParams(location.search);
        const sessionId = query.get("session_id");

        if (!sessionId) {
          setError("❌ No session ID found.");
          return;
        }

        // const token = localStorage.getItem("token");
        // const isExpired = isTokenExpired(token);

        // if (!token || isExpired) {
        //   setError("⚠ Session expired or unauthorized.");
        //   return;
        // }

        const { data } = await axios.get(
          `${API_URL}/api/orders/verify-payment?sessionId=${sessionId}`
          // { headers: { Authorization: `Bearer ${token}` } }
        );

        if (data.status === "paid") {
          setMessage("✅ Payment successful! Your order is now being processed.");
          setTimeout(() => {
            navigate('/')
  }, 3000); // 3 seconds delay
        } else if (data.status === "pending") {
          setMessage("⌛ Payment is still pending. We'll notify you once it's confirmed.");
          setTimeout(() => {
    navigate("/");
  }, 3000); // 3 seconds delay
        } else {
          setError("❌ Payment not completed or failed.");
          setTimeout(() => {
    navigate("/");
  }, 3000); // 3 seconds delay
        }
      } catch (err) {
        console.error("Error verifying payment:", err);
        setError("⚠ Could not verify payment.");
      }
    };

    verifyPayment();
  }, [location]);

  return (
    <div style={{ padding: "2rem" }}>
      {message && <p style={{ color: "green" }}>{message}</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default PaymentSuccess;
